<!--
 * @Descripttion: 项目选择列表
 * @version: v1
 * @Author: Terry
 * @Date: 2020-06-05 10:22:26
 * @LastEditors: Terry
 * @LastEditTime: 2023-02-23 12:28:18
-->
<template>
  <div >
    <!-- //头部 -->
      <navbar></navbar>
      <!--中间 -->
      <div> 
        <el-row >  
          <el-col :span="6"  v-for="(item , index) in list" :key="index" >
            <div class="gutter" @click="toProject(item.projectCode,item.name)">
              <div class="flex prjList">
                  <div class="title"><strong>( {{item.prjStatus}} ) {{item.name}}  </strong></div>
                  <div class="code">在场/考勤 : {{item.memberEntryCount}} / {{item.attendanceCount}} </div> 
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="flex pag">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size='searchForm.limit'
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
        <!-- //底部 -->
       <div  class='w-100 footer'>
         <div>
          <strong>
            <span class="text-gray">
              ©版权所有
            </span>
            <a href="https://beian.miit.gov.cn/" class="text" target="_blank">粤ICP备2020130674号-1</a>
          </strong> 
         </div>
      </div>
  </div>
</template>
<style lang="scss"scoped>
  .gutter{
    margin: 1vh  10px  ;
  }
  .flex{
    display: flex;
  }
  .text{
    text-decoration: none;
    color: #d9e6f3;
    text-shadow:#000000 3px 2px 1px
  }
  .footer{
    position: absolute;
    bottom: 10px;
    text-align: center;
  }
  .pag{
    justify-content: center;
    margin-top: 1vh;
  }
  .prjList{
    color:white;
    border-radius: .5rem;
    // margin-bottom: 1.5rem;
    padding: 1rem;
    height: 12.5vh;
    background: rgba(73, 72, 72, 0.3);
    box-shadow: 0 0 0 1px hsla(0,0%,100%,.3) inset, 0 .5em 1em rgba(0, 0, 0, 0.6);
    cursor: pointer;
    justify-content: space-evenly;
    flex-direction: column;
    .title{
      text-overflow:ellipsis;
      // white-space: nowrap;//禁止换行
      overflow: hidden;
      width: 100%;
      font-size: .8rem;
    }
    .code{
      font-size: .6rem;
    }
    &:hover{
       background: rgba(73, 72, 72, 0.8);
    }
  }
</style>
<script>
import navbar from '../../../components/navbar'; 
  export default {
    components:{
      navbar,
    },
    data () {
      return {
        list:[],
        total:0,
        searchForm:{
          page:1,
          limit:16
        },
        cellLoad:true,
        cellData:[],
      }
    },

    methods: {
      // 分页
       handleCurrentChange(val) {
         this.tableLoad = true;
         this.searchForm.page = val;
         this.getList();
      },
   // 获取列表
      getList(){
        var load = this.loading();
        this.axios.get(this.api.project.getList,{params:this.searchForm}).then( res => {
            this.list = res.data.list;
            this.total = res.data.count;
            console.log(this.total);
        }).finally(()=>{
            load.close();
        })
      },
         /**
        * [toPorject 跳转到项目]
        * @param  {[type]} cuuid [公司营业执照号码]
        * @param  {[type]} prjCode [项目uuid]
        * @return {[type]}       [description]
        */
        toProject(prjCode,name){
          sessionStorage.setItem('prjCode',prjCode);
          sessionStorage.setItem('projectName',name);
          this.$router.push({ name:'certification' })
        }, 
    },
    mounted(){
      this.getList();
    }
  }
</script>